module.exports = __webpack_public_path__ + "img/rarity6.6e9e05e3.png";